import React, {useEffect} from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {deleteApplication, fetchApplications, swapPositions,} from '../reducers/recordsSlice';

import {useDefaultSigninOption} from 'hooks/useDefaultSigninOption';

import {applicationsSelector} from '../selectors';

import ReturnToSection from '../components/ReturnToSection';

import styled from 'styled-components';

export const ButtonIconWrapper = styled.div`
    padding-top: 20%;
`;

export const IndexPage = () => {
    const dispatch = useDispatch();

    const { defaultOption } = useDefaultSigninOption();

    const { show_return_to, max_return_to } = defaultOption;

    const applications = useSelector((state) =>
        applicationsSelector(state, max_return_to)
    );

    useEffect(() => {
        dispatch(fetchApplications());
    }, [dispatch]);

    const handleRemoveApplication = (application) => {
        dispatch(deleteApplication(application.id));
        return false;
    };

    const handleSwapPositions = () => {
        dispatch(swapPositions());
    };

    if (show_return_to === null) {
        return <div>Loading</div>;
    }

    if (show_return_to === true && Array.isArray(applications)) {
        return (
            <React.Fragment>
                <ReturnToSection
                    applications={applications}
                    deleteApplication={handleRemoveApplication}
                    swapPositions={handleSwapPositions}
                />
            </React.Fragment>
        );
    } else {
        return null;
    }
};
